'use strict';
// import 'slick-carousel';

window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
require('base/main');
processInclude(require('./utilities'));
$(document).ready(function () {
  setTimeout(() => {
    processInclude(require('./components/menu'));
    // processInclude(require('./components/consentTracking'));
    // processInclude(require('./login/login'));
    // processInclude(require('./customSelect'));
    processInclude(require('./wishlist'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./cart/cart'));
    processInclude(require('./components/miniCart'));
    // processInclude(require('./search/search'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/customToolTip'));
  }, 1000);
});

// require('./commonScript');
// require('./product/initSlick');
// require('./product/pdpZoom');
// require('./pincodeMapping');
// require('./product/pdpCustom');
// require('./cart/sfmcTrackCart');
// require('./wishlist/sfmcWishlistTrack');
// require('./product/productVideo');
// require('./components/gtm-components');
// require('./components/gtm-components-footer');
// require('buyNow/buyNow');
// require('goKwik/gokwikcheckout');

function getElement(selector) {
  return document.querySelectorAll(selector).length > 0;
}

function loadModules() {
    getElement('[data-lazyload-src]') && require('./modules/module.lazyload');
    getElement('.product-video') && require('./product/productVideo');
    getElement('.product-detail') && require('./product/pdpCustom');
    getElement('.product-detail') && require('./product/pdpZoom');
    (getElement('.homepage ') || getElement('.quickview') || getElement('.buy-now') || getElement('.gokwik-checkout')) && require('buyNow/buyNow');
    (getElement('.homepage ') || getElement('.quickview') || getElement('.buy-now') || getElement('.gokwik-checkout')) && require('goKwik/gokwikcheckout');

    getElement('.custom-mv-select') && processInclude(require('./customSelect'));
    getElement('.search-results') && processInclude(require('./search/search'));

    require('./commonScript');
    require('./pincodeMapping');
    require('./product/initSlick');
    require('./cart/sfmcTrackCart');
    require('./wishlist/sfmcWishlistTrack');
    require('./components/gtm-components');
    require('./components/gtm-components-footer');

    //track cjevent for cj affiliate
    require('./cjEvent');

    //snapmint integration
    getElement('[data-snapmint-offer]') && require('./snapmint/snapmint');

    processInclude(require('./login/login'));

    setTimeout(() => {
      processInclude(require('./components/consentTracking'));
    }, 1000);

    require('./login/postLoginHandling');
}

loadModules();
